import { Navigate } from 'react-router-dom'
import { FullPageLoader, FullPageMessage } from '../components/FullPageState'
import { usePreviewStore } from '../preview/previewStore'
import { useAuth } from './useAuth'

/**
 * Guard de autenticação. Não monta listener (responsabilidade de <AuthInit />).
 * Estados:
 * - loading: spinner
 * - sem sessão: redirect para /login
 * - sessão sem profile vinculado: tela "Acesso não configurado"
 * - autenticado e configurado: renderiza children
 */
export function RequireAuth({ children }) {
  const { loading, session, isUnconfigured } = useAuth()
  const isPreview = usePreviewStore((s) => s.isPreview)
  const previewSessionReady = usePreviewStore((s) => s.sessionReady)

  if (loading) return <FullPageLoader label="Verificando sua sessão..." />
  // Em modo preview, a sessao chega via postMessage logo apos o boot. Enquanto
  // ela nao chega, espera em vez de redirecionar pro login dentro do iframe.
  if (isPreview && !session && !previewSessionReady) {
    return <FullPageLoader label="Abrindo preview..." />
  }
  if (!session) return <Navigate to="/login" replace />
  if (isUnconfigured) {
    return (
      <FullPageMessage
        title="Acesso não configurado"
        message={
          'Sua conta ainda não foi vinculada a nenhum projeto.\n' +
          'Entre em contato com seu gerente de projeto na Infosaas.'
        }
      />
    )
  }
  return children
}
